export type SierraDeviceState = {
    gatewayLoading: boolean;
    gatewaySuccess: boolean;
    loading: boolean;
    success: boolean;
    errorCode: string;
    hasData: boolean;
    deleteSuccess: boolean;
    deleteMessage: string;
    selectedChildDevices: string[];
    exerthermUnitIdValidation: boolean;
    deleteChildDeviceLoading: boolean;
    deleteChildDeviceSuccess: boolean;
};
export const initialSierraDevice: SierraDeviceState = {
    gatewayLoading: false,
    gatewaySuccess: false,
    loading: false,
    success: false,
    errorCode: '',
    hasData: true,
    selectedChildDevices: [],
    exerthermUnitIdValidation: false,
    deleteSuccess: false,
    deleteMessage: "",
    deleteChildDeviceLoading: false,
    deleteChildDeviceSuccess: false,
};
